import React from 'react';
import PropTypes from 'prop-types';

import AraraIconButton from '../AraraIconButton';


const AddButton = ({ onClick, className }) => (
  <AraraIconButton
    onClick={onClick}
    iconName="button-add"
    hoveredIconName="button-add-hover"
    className={className}
  />
);


AddButton.defaultProps = {
  className: '',
};

AddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default AddButton;
